import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  DashboardOutlined,
  ShoppingOutlined,
  TeamOutlined,
  InboxOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,  HomeOutlined,
  MenuOutlined,
  CloseOutlined,
  TagsOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  AppstoreOutlined

} from '@ant-design/icons';
import logo from '../../images/Layout/logo3.svg';
import styles from './Navbar.module.scss';
import { isAuthenticated, isAdmin, removeAllCookies } from '../../../Services/auth';
import { AppState } from '../../../store';
import { removeItem, updateCantidad } from '../../../store/Carrito/actions';
import { CarritoDropdown } from '../../../Components/Commerce/Carrito/CarritoDropdown';
interface NavbarProps {
  onMenuToggle?: () => void;
}

const promoMessages = [
  'Alcanza $100 en tu compra y elige tu beneficio: descuento especial o mini producto de regalo ✨',
  'PRODUCTOS 100% ORIGINALES CON ASESORÍA PERSONALIZADA',
];

const Navbar: React.FC<NavbarProps> = ({ onMenuToggle }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loggedIn, setLoggedIn] = useState(isAuthenticated());
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [carritoOpen, setCarritoOpen] = useState(false);
  const [promoVisible, setPromoVisible] = useState(true);
  const [promoPaused, setPromoPaused] = useState(false);
  const [promoIndex, setPromoIndex] = useState(0);

  const admin = isAdmin();
  const menuItems = [
    { label: 'Home',      path: '/dashboard', icon: <HomeOutlined /> },
    { label: 'Productos', path: '/products',  icon: <ShoppingOutlined /> },
    { label: 'Combos / Rutinas', path: '/products?categoria=RUTINAS', icon: <AppstoreOutlined /> },
    { label: 'Ofertas',   path: '/ofertas',   icon: <TagsOutlined />, highlight: true },
    ...(admin ? [{ label: 'Reservas', path: '/reservas', icon: <FileTextOutlined /> }] : []),
    ...(loggedIn && !admin ? [{ label: 'Mis reservas', path: '/mis-reservas', icon: <FileTextOutlined /> }] : []),
  ];

  const carritoItems = useSelector((state: AppState) => state.carritoAction.items);
  const totalItems = carritoItems.reduce((sum, item) => sum + item.cantidad, 0);

  const handleNavClick = (path: string) => {
    history.push(path);
    setMobileNavOpen(false);
  };

  const handleReservar = () => {
    setCarritoOpen(false);
    history.push('/carrito');
  };

useEffect(() => {
    // Re-evalúa cuando cambia la autenticación
    const handleSessionExpired = () => setLoggedIn(false);
    window.addEventListener('session-expired', handleSessionExpired);
    return () => window.removeEventListener('session-expired', handleSessionExpired);
  }, []);

  useEffect(() => {
    if (!promoVisible || promoPaused) return;

    const timer = window.setInterval(() => {
      setPromoIndex(index => (index + 1) % promoMessages.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, [promoPaused, promoVisible]);

  const handleLogout = () => {
    //localStorage.removeItem('token');
    removeAllCookies();
    setLoggedIn(false);
    history.push('/');
  };
  const handleLogin = () => {
    history.push('/login');
  };

  return (
    <header className={styles.navbarShell}>
      {promoVisible && (
        <div
          className={`${styles.navbarShell__promo} ${promoPaused ? styles['navbarShell__promo--paused'] : ''}`}
          onMouseEnter={() => setPromoPaused(true)}
          onMouseLeave={() => setPromoPaused(false)}
          onFocus={() => setPromoPaused(true)}
          onBlur={() => setPromoPaused(false)}
          role="region"
          aria-label="Promoción de Glow Skin"
        >
          <div className={styles.navbarShell__promoInner}>
            <span className={styles.navbarShell__promoIcon} aria-hidden="true">✦</span>
            <div className={styles.navbarShell__promoWindow} aria-live="polite">
              <span key={promoIndex} className={styles.navbarShell__promoMessage}>
                {promoMessages[promoIndex]}
              </span>
            </div>
            <button
              type="button"
              className={styles.navbarShell__promoClose}
              onClick={() => setPromoVisible(false)}
              aria-label="Cerrar promoción"
            >
              ×
            </button>
          </div>
        </div>

      )}

      <div className={styles.navbar}>
        <div className={styles.navbar__left}>
          <div className={styles.navbar__logoWrap}>
            <img
              src={logo}
              alt="Glow Skin by Sami"
              className={styles['navbar__logo']}
            />
            <span className={styles.navbar__signature}>By Sami</span>
          </div>
        </div>

        <nav className={`${styles.navbar__nav} ${mobileNavOpen ? styles['navbar__nav--open'] : ''}`}>
          {menuItems.map((item) => (
            <div
              key={item.path}
              className={`${styles['navbar__nav-item']} ${item.highlight ? styles['navbar__nav-item--highlight'] : ''}`}
              onClick={() => handleNavClick(item.path)}
            >
              <span>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </nav>
        <div className={styles.navbar__right}>
          <div className={styles.navbar__cartWrap}>
            <button
              className={styles.navbar__cartBtn}
              onClick={() => setCarritoOpen(open => !open)}
              aria-label="Mi carrito"
            >
              <ShoppingCartOutlined />
              {totalItems > 0 && <span className={styles.navbar__cartBadge}>{totalItems}</span>}
            </button>

            {carritoOpen && (
              <>
                <div className={styles.navbar__cartBackdrop} onClick={() => setCarritoOpen(false)} />
                <div className={styles.navbar__cartDropdown}>
                  <CarritoDropdown
                    items={carritoItems}
                    onClose={() => setCarritoOpen(false)}
                    onRemove={(productoId) => dispatch(removeItem(productoId))}
                    onUpdateCantidad={(productoId, cantidad) => dispatch(updateCantidad(productoId, cantidad))}
                    onReservar={handleReservar}
                  />
                </div>
              </>
            )}
          </div>

          <button
            className={styles.navbar__hamburger}
            onClick={() => setMobileNavOpen(open => !open)}
            aria-label={mobileNavOpen ? 'Cerrar menú' : 'Abrir menú'}
          >
            {mobileNavOpen ? <CloseOutlined /> : <MenuOutlined />}
          </button>
          {loggedIn ? (
            <button className={styles.navbar__logout} onClick={handleLogout}>
              Cerrar sesión
            </button>
          ) : (
            <button className={styles.navbar__login} onClick={handleLogin}>
              Iniciar sesión
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
